import React, { useState, useEffect } from "react";
import axios from "axios";

function useAlertBanner() {
  const [alerts, setAlerts] = useState([]);

  const getAlerts = async () => {
    await axios.get("/api/v1/hwts/alerts").then((res) => {
      setAlerts(res.data);
    });
  };
  useEffect(() => {
    getAlerts();
  }, []);
  return alerts;
}

export default useAlertBanner;
